import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IVariant, IWineClub } from '../../../settings/app.settings';
import { WineClubDataStore } from '../wine-club-data';
import { IWineClubSignupConfig, IWineClubSignupResources } from '../wine-club-signup.props.autogenerated';

export interface IWinePreference {
    clubInfo: IWineClub[];
    config: IWineClubSignupConfig;
    resources: IWineClubSignupResources;
}

/**
 * wine preference def
 */
export class WinePreference extends React.Component<IWinePreference> {
    private _clubStore: WineClubDataStore;

    public constructor(props: IWinePreference) {
        super(props);

        this._onVariantChangeByList = this._onVariantChangeByList.bind(this);
        this._onVariantChangeByButton = this._onVariantChangeByButton.bind(this);

        this._clubStore = WineClubDataStore.getInstance();
    }

    public render(): JSX.Element {
        const { clubId } = this._clubStore.get();

        if (clubId === null) {
            return <div />; // insurance if not caught in view;
        }

        const club = this.props.clubInfo[clubId];

        if (!club) {
            return <div />; // more insurance
        }

        const variants = club.variants;

        if (variants.length === 1) {
            this._autoselectVariant(club.variants[0]);
            return <div />; // dont need to render when there are no variants
        }

        return (
            <div className='wine-club-signup-wine-preference'>
                <h2 className='wine-club-signup-wine-preference-title'>{this.props.config.choosePreference?.title || this.props.resources.wineClubSignup__stepTwo}</h2>
                {this.props.config.choosePreference?.subtitle && <RichTextComponent className='wine-club-signup-wine-preference-subtitle' text={this.props.config.choosePreference.subtitle} />}
                <div className='wine-club-signup-wine-preference-buttons'>
                    {variants.length <= 3 && this._renderAsButtons(club)}
                    {variants.length > 3 && this._renderAsList(club)}
                </div>
            </div>
        );
    }

    private _autoselectVariant(variant: IVariant): void {
        const store = this._clubStore.get();

        // we dont want an infinite render loop, do we?
        if (store.variantPreference === variant.winePreference) { return; }
        store.variantPreference = variant.winePreference;
        this._clubStore.edit(store);
    }

    private _renderAsButtons(club: IWineClub): JSX.Element[] {
        const { variantPreference } = this._clubStore.get();
        return club.variants.map((variant, idx) => {
            return (
                <button
                    key={idx}
                    value={variant.winePreference}
                    disabled={variantPreference === variant.winePreference}
                    onClick={this._onVariantChangeByButton}
                    className='wine-club-signup-wine-preference-button'
                >
                    {variant.winePreference}
                </button>
            );
        });
    }

    private _renderAsList(club: IWineClub): JSX.Element {
        const store = this._clubStore.get();
        if (store.variantPreference === null) {
            this._autoselectVariant(club.variants[0]);
        }
        return (
            <select value={store.variantPreference || club.variants[0].winePreference} onChange={this._onVariantChangeByList}>
                {
                    club.variants.map(
                        (variant, idx) => (
                            <option
                                value={variant.winePreference}
                                aria-selected={store.variantPreference === variant.winePreference}
                                key={idx}
                            >
                                {variant.winePreference}
                            </option>
                        )
                    )
                }
            </select>
        );
    }

    private _onVariantChangeByButton(event: React.MouseEvent<HTMLButtonElement>): void {
        const store = this._clubStore.get();
        store.variantPreference = (event.target as HTMLButtonElement).value;
        this._clubStore.edit(store);
    }

    private _onVariantChangeByList(event: React.ChangeEvent<HTMLSelectElement>): void {
        const store = this._clubStore.get();
        store.variantPreference = event.target.value;
        this._clubStore.edit(store);
    }
}